import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import {platformBrowser} from "@angular/platform-browser";
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import {MinicheckModule} from "./app/minicheck/minicheck.module";

Sentry.init({
  dsn: "https://ceef8484c0624451ab97d87e0a995c2f@sentry.co2online.de/10",
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'fetch' && breadcrumb.data && breadcrumb.data.url && breadcrumb.data.url.match(/^data/)) {
      return null;
    }
    return breadcrumb;
  },

  enabled: environment.production === true && window.location.host.indexOf('ddev.site') === -1,

  environment: window.location.host.indexOf('-dev') > 0 ? 'stage' : 'production',

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
Sentry.setTag('page_locale', navigator['browserLanguage'] ?? navigator.language);

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(MinicheckModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
